<template>
  <div v-if="items.length" class="patient-tag-badges" :class="{ 'is-compact': compact }">
    <span
      v-for="tag in items"
      :key="tag.id_tag"
      class="badge badge-light-primary"
      :title="tag.tag_name"
    >{{ label(tag.tag_name) }}</span>
  </div>
</template>

<script>
const MAX_LABEL_LENGTH = 18;

export default {
  name: 'PatientTagBadges',
  props: {
    tags: { type: Array, default: () => [] },
    compact: { type: Boolean, default: false },
  },
  computed: {
    items() {
      return (this.tags || []).filter((tag) => tag && tag.tag_name);
    },
  },
  methods: {
    label(name) {
      const value = String(name || '').trim();
      if (value.length <= MAX_LABEL_LENGTH) {
        return value;
      }
      return `${value.slice(0, MAX_LABEL_LENGTH)}…`;
    },
  },
};
</script>

<style scoped>
.patient-tag-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem;
  min-width: 0;
}
.patient-tag-badges .badge {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.patient-tag-badges.is-compact .badge {
  padding: 0.08rem 0.32rem;
  font-size: 0.58rem;
}
</style>
